<template>
  <div>
    <el-select
      v-model="place[0]"
      :disabled="diss[0]?true:false"
      clearable
      style="margin-right:15px;"
      ref="mchild"
      filterable
      @change="remoteMethod($event,1)"
      placeholder="省">
      <el-option v-for="(o,i) in value.province" :key="i" :label="o.name" :value="o.id">
        <span style="float: left">{{ o.name }}</span>
      </el-option>
    </el-select>
    <el-select
      v-model="place[1]"
      :disabled="diss[1]?true:false"
      clearable
      style="margin-right:15px;"
      ref="mchild1"
      filterable
      @change="remoteMethod($event,2)"
      placeholder="市">
      <el-option v-for="(o,i) in value.city" :key="i" :label="o.name" :value="o.id">
        <span style="float: left">{{ o.name }}</span>
      </el-option>
    </el-select>
    <br />
    <el-select
      v-model="place[2]"
      :disabled="diss[2]?true:false"
      clearable
      style="margin-top:18px;margin-right:15px;"
      ref="mchild2"
      filterable
      @change="remoteMethod($event,3)"
      placeholder="县">
      <el-option v-for="(o,i) in value.county" :key="i" :label="o.name" :value="o.id">
        <span style="float: left">{{ o.name }}</span>
      </el-option>
    </el-select>
    <el-select
      v-model="place[3]"
      :disabled="diss[3]?true:false"
      clearable
      style="margin-top:18px;"
      ref="mchild3"
      filterable
      @change="remoteMethod($event,4)"
      placeholder="镇/乡">
      <el-option v-for="(o,i) in value.town" :key="i" :label="o.name" :value="o.id">
        <span style="float: left">{{ o.name }}</span>
      </el-option>
    </el-select>
    <br />
    <el-select
      v-model="place[4]"
      :disabled="diss[4]?true:false"
      clearable
      style="margin-top:18px;"
      ref="mchild4"
      filterable
      @change="remoteMethod($event,5)"
      placeholder="村">
      <el-option v-for="(o,i) in value.village" :key="i" :label="o.name" :value="o.id">
        <span style="float: left">{{ o.name }}</span>
      </el-option>
    </el-select>
  </div>
</template>

<script>
// import {mixins} from "../../Mixins";
export default {
  // mixins:[mixins],
  props: {
    value: Object,
    name: Array,
    arr: Array,
    diss: Array
  },
  data() {
    return {
      place: ['', '', '', '', ''],
      key: 5
    }
  },
  created() {},
  methods: {
    //选择某项时获取下一项的地点数据
    remoteMethod(value, str) {//value指的是 值发生改变的下拉框的区域名指向的区域id
      let areaName = [];
      // let areaNameId = []; 
      switch (str) {
        case 1:
          this.place[1] = this.place[2] = this.place[3] = this.place[4] = '';
          areaName[str - 1] = this.getName(value, this.value.province);//通过区域id拿到区域名
          break;
        case 2:
          this.place[2] = this.place[3] = this.place[4] = '';
          areaName[str - 1] = this.getName(value, this.value.city);
          break;
        case 3:
          this.place[3] = this.place[4] = '';
          areaName[str - 1] = this.getName(value, this.value.county);
          break;
        case 4:
          this.place[4] = '';
          areaName[str - 1] = this.getName(value, this.value.town);
          break;
        case 5:
          areaName[str - 1] = this.getName(value, this.value.village);
          break;
      }
      this.$emit("getPlace", {
        value: { areaId: value },
        key: str,
        name: areaName[str - 1]
      })
    },
    //获取id对应name
    getName(id, arr) {
      let a = ''
      for (let i = 0; i in arr; i++) {
        const o = arr[i]
        if (o.id == id) {
          a = o.name
        }
      }
      return a
    }
  },
  watch: {
    name(value) {
      this.place = this.name
    },
    arr(value) {
      this.place = this.arr
    },
    immediate: true, //关键
    deep: true
  },
  created() {
    console.log(this.name, this.arr)
  },
}
</script>
